export default {
  // Side Navigation
  navigation: {
    home: 'Home',
    gameCenter: 'Game Center',
    rechargeCenter: 'Recharge Center',
    imChat: 'IM Chat',
    consult: 'Consulting',
    starcast: 'Group Entertainment Live Streaming Platform'
  },

  // Home
  home: {
    platformFeatures: 'Platform Features',
    quickActionsName: 'Quick Actions',
    footerText: 'Make streaming simpler and interaction more fun',
    features: {
      gameCenter: {
        title: 'Game Center',
        description: 'Rich game resources supporting multi-platform streaming',
      },
      imChat: {
        title: 'Instant Messaging',
        description: 'Real-time chat interaction to enhance viewer experience',
      },
      dataAnalysis: {
        title: 'Data Analysis',
        description: 'Detailed statistics to optimize streaming performance',
      },
      efficientStable: {
        title: 'Efficient & Stable',
        description: 'Smooth streaming experience with reliable service',
      },
    },
    stats: {
      activeUsers: 'Active Users',
      gameResources: 'Game Resources',
      serviceAvailability: 'Service Availability',
      technicalSupport: 'Technical Support',
    },
    quickActions: {
      gameCenter: 'Game Center',
      imChat: 'IM Chat',
      consult: 'Consulting',
    },
  },

  // Game Center
  gameCenter: {
    language: 'English',
    balance: 'Balance',
    hotGames: 'Hot Games',
    download: 'Download',
    update: 'Update',
    startTikTok: 'Start',
    startBigo: 'Start',
    document: 'Document',
    currentGame: 'Current Live Game: ',
    currentStatus: 'Current Live Status: ',
    recharge: 'Recharge',
    restart: 'Restart Tools and Games',
    closeLive: 'Close Live',
    downloadProgress: 'Download Progress: ',
    decompProgress: 'Decompression Progress: ',
    waitDecomp: 'Waiting for Decompression',
    fixBug: 'Fix Bug',
    clickUpdate: 'Click Update',
    downloading: 'Downloading, please wait patiently~',
    pay: 'Paying...',
    xzf: 'Need Payment',
    zs: 'Diamond',
    dest: 'Danmu Game Anti-Blocking Plugin',
    getff: 'Unlock Plugin',
    ffbtun: 'Anti-machine review broadcast',
    qrkb: 'Confirm Live Stream',
    tkl: 'Are you ready to start anti-machine review and broadcast?',
    qd: 'Confirm',
    qx: 'Cancel',
  },

  // IM Chat
  imChat: {
    search: 'Search',
    searchNoResult: 'User not found',
    tryOtherKeywords: 'Please try other keywords',
    noConversations: 'No chat history',
    startChatting: 'Search users to start chatting',
    loadingConversations: 'Loading conversations...',
    connecting: 'Connecting to chat server...',
    connectionFailed: '⚠️connection failed, chat unavailable',
    checkNetwork: 'Please check network or contact support',
    selectUser: 'Please select a user to start chatting',
    sending: 'Sending...',
    sendMessage: 'Send',
    enterMessage: 'Enter message...',
    noMessages: 'No messages',
    officialUser: 'XingYu Interactive',
    welcomeChat: 'Welcome to Chat',
    selectConversationHint: 'Please select a conversation from the left to start chatting',
    inputDisabledDisconnected:
      'The connection has been disconnected. Chat is temporarily unavailable. Other functions are normal. Please log in again to restore the chat function.',
    inputDisabledOfficialNotification:
      'Official notifications are one-way, you can only receive messages',
    RecentSessions: 'Recent Sessions',
    RecommendedChat: 'Global Friends',
    Online: 'Online',
    Offline: 'Offline',
  },

  // 咨询
  StalConsult: {
    search2: 'Search',
    all: 'All',
    Payment: 'Payment',
    ViewFullContent: 'View Full Content',
    UnlockFullContent: 'Unlock Full Content',
    NeedToPay: 'Need to Pay',
    diamond: 'Diamond',
    CurrentBalance: 'Current Balance',
    Cancel: 'Cancel',
    PayNow: 'Pay Now',
    InsufficientBalance: 'Insufficient Balance',
    loading: 'Loading...',
    NoMoreContent: 'No More Content',
    return: 'Back',
    fd: 'Zoom in to view',
  },

  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    loading: 'Loading...',
    success: 'Success',
    failed: 'Failed',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
  },
}
